import { render, staticRenderFns } from "./PriceInput.vue?vue&type=template&id=5ecb480c&"
import script from "./PriceInput.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PriceInput.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ecb480c')) {
      api.createRecord('5ecb480c', component.options)
    } else {
      api.reload('5ecb480c', component.options)
    }
    module.hot.accept("./PriceInput.vue?vue&type=template&id=5ecb480c&", function () {
      api.rerender('5ecb480c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/FieldPrices/components/PriceInput.vue"
export default component.exports